
<div class="pre-bin-check"
     [innerHTML]="context?.content?.headlineContent?.content|contentParse:context.menu|safeHtml">
</div>
<ap-bin-check [title]="'binChecker.title'|content"
              [binLabel]="'binChecker.binLabel'|content"
              [binNumberControlHeader]="'binChecker.binNumberControlHeader'|content"
              [cardSelectLabel]="'binChecker.cardSelectLabel'|content"
              [checkBinLabel]="'binChecker.checkingBinLabel'|content"
              [selectCardFromLabel]="'binChecker.findCardContent'|htmlContent"
              [resetCardLabel]="'binChecker.tryAnotherCardContent'|htmlContent"
              [validationMessages]="'validationMessages.fieldErrors'|content"
              [showButton]="false"
              [emitOnSelectionChange]="true"
              [validationMessages]="'validationMessages.fieldErrors'|content"
              [displayOption]="cardOptionQuery.values | async"
              [cards]="cardQuery.values | async"
              [noBinError]="showBinNotFound"
              [alternativeBinError]="showAlternativeBinFound"
              (selected)="onCardSelected($event)"
              (binSearch)="onBinSearch($event)"
              (reset)="resetBin()"
              (clearAlternativeBinError)="onClearAlternativeBinError()">
</ap-bin-check>
<div *ngIf="selectedCard"
     [innerHTML]="('benefitTables.cardBenefits'|content|first:'cardType':selectedCard.cardType.code:{})[context?.content?.productName]?.content|contentParse:contentData | safeHtml">
</div>
<div class="post-bin-check"
     [innerHTML]="context?.content?.pageContent?.content|contentParse|safeHtml">
</div>
